import axios from './axios-instance';

// 下载资源文件
export function apiDownloadFile(params) {
  return axios.get('/brand-thirdremote/comm-platform/file/download', {
    params,
    responseType: 'blob',
    headers: {
      type: 'brand',
    },
  })
}
